export default __webpack_public_path__ + "static/media/craon8.46c79000.jpg";